import {LazyAsync, RestClient} from "zavadil-ts-common";
import {ContactTypeView} from "../../types/ContactType";

export class ContactTypesClient {

	client: RestClient;

	lazy: LazyAsync<Array<ContactTypeView>>;

	constructor(client: RestClient) {
		this.client = client;

		this.lazy = new LazyAsync(() => this.client.getJson('contact-type/all'));
	}

	all(): Promise<Array<ContactTypeView>> {
		return this.lazy.get();
	}

	bySource(sourceId: string): Promise<Array<ContactTypeView>> {
		//return this.client.getJson('contact-type/by-source', {sourceId});
		return this.all().then((types) => types.filter((t) => t.source.id === sourceId));
	}

	load(id: number): Promise<ContactTypeView | undefined> {
		return this.all().then((types) => types.find((t) => t.id === id));
	}

}
